import { useCallback } from "react"

import { useToast } from "src/hooks/use_toast"

import { notifyBugsnag } from "src/utils/bugsnag"

export const useCopyToClipboard = () => {
  const showToast = useToast()

  return useCallback(
    async (text, successMessage) => {
      try {
        await navigator.clipboard.writeText(text)
      } catch (error) {
        if (error?.name !== "NotAllowedError") {
          notifyBugsnag(error, { clipboard: { stage: "writeText" } })
        }
        showToast(
          "Couldn't copy to clipboard. Click on the page and try again, or copy it manually.",
          {
            type: "error",
          }
        )
        return
      }
      showToast(successMessage, { type: "success" })
    },
    [showToast]
  )
}
